import { AddonSchedule, AddonScheduleMode, AddonOccurrence } from 'types/AddonSchedule';
import { AddonService } from 'types/AddonService';
import { PortalBookingAppointment } from 'types/PortalBooking';

export const DEFAULT_ADDON_QUANTITY = 1;

export const createDefaultSchedule = (): AddonSchedule => ({
    mode: AddonScheduleMode.Everyday,
    quantity: DEFAULT_ADDON_QUANTITY,
    days: {}
});

export const addonFitsBusinessArea = (addon: AddonService, businessArea: string | null) =>
    addon.businessAreas.length === 0 ||
    (businessArea !== null && addon.businessAreas.includes(businessArea));

// Same rule as the backend (PortalAddonEligibility): the add-on has no business area or the one
// of the appointment's service, and only the dates the backend still offers for that appointment.
export const getAddonDates = (
    addon: AddonService,
    appointments: Array<PortalBookingAppointment>
): Array<string> => {
    const dates = new Set<string>();

    appointments
        .filter(appointment => addonFitsBusinessArea(addon, appointment.service.businessArea))
        .forEach(appointment => appointment.addonDates.forEach(date => dates.add(date)));

    return Array.from(dates).sort();
};

export const getScheduleOccurrences = (
    schedule: AddonSchedule,
    eligibleDates: Array<string>
): Array<AddonOccurrence> => {
    if (schedule.mode === AddonScheduleMode.Everyday) {
        return eligibleDates.map(date => ({ date, quantity: schedule.quantity }));
    }

    return eligibleDates
        .filter(date => schedule.days[date] !== undefined)
        .map(date => ({ date, quantity: schedule.days[date] }));
};

export const getScheduleUnits = (schedule: AddonSchedule, eligibleDates: Array<string>) =>
    getScheduleOccurrences(schedule, eligibleDates).reduce(
        (units, occurrence) => units + occurrence.quantity,
        0
    );

// pet x Add-On x date x quantity, before taxes.
export const getScheduleSubtotal = (
    price: number,
    schedule: AddonSchedule,
    eligibleDates: Array<string>
) => Math.round(price * getScheduleUnits(schedule, eligibleDates) * 100) / 100;
